<script setup>
  import ComponentIcon from "@components/Icons/Icon.vue";
  import {MedLink, MedTooltip} from "@pharma4u/medicheck-components";

  defineOptions({
    name: "PagesRecordResultOverviewRedlights",
  });

  const props = defineProps({
    checks: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    anchorPrefix: {
      type: String,
      required: true,
    },
  });

  function toggleCheckOpen(check) {
    let element = document.querySelector(getAnchor(check) + " ol li:first-child [role=button]");

    if (element) {
      element.click();
    }
  }

  function getAnchor(check) {
    return "#" + props.anchorPrefix + "-" + check.mc_check_id;
  }
</script>

<template>
  <div class="border-1 border-mcred p-2 text-mcred-700" :data-test="getTestId('redlights')">
    <div class="-mx-2 -mt-2 flex cursor-default items-center space-x-2 border-b-1 border-mcred bg-mcred-100 px-2 py-3">
      <ComponentIcon class="text-xl">error_outline</ComponentIcon>
      <h3 class="inline font-semibold">{{ title }}</h3>
      <span class="font-light">(Details s. u.):</span>
    </div>

    <ul class="mt-2 space-y-2 print:break-before-avoid-page">
      <li
        v-for="(check, index) in checks"
        :key="check.id"
        class="flex items-start justify-between space-x-2"
        :data-test="getTestId(`redlights-${index}`)"
      >
        <div class="flex items-start space-x-2">
          <MedTooltip :content="check.claims[0].description">
            <MedLink
              variant="primary"
              icon="chevron_right"
              class="text-mcred-700 decoration-mcred-700"
              :href="getAnchor(check)"
              :data-test="getTestId(`redlights-${index}-anchor-link`)"
              @click="toggleCheckOpen(check)"
            >
              {{ check.claims[0].claim }}
            </MedLink>
          </MedTooltip>
        </div>

        <!-- TODO replace elements with components -->
        <div class="flex items-center space-x-1 print:hidden">
          <MedTooltip v-if="check.comment_count > 0" content="Kommentare zwischen Partnern der Fallfreigabe">
            <MedLink
              variant="primary"
              icon="mode_comment"
              class="text-mcred-700"
              :href="getAnchor(check)"
              :data-test="getTestId(`redlights-${index}-comment-link`)"
              @click="toggleCheckOpen(check)"
            />
          </MedTooltip>

          <MedTooltip v-if="check.confidential_comment_count > 0" content="Rückmeldung des Arztes">
            <MedLink
              variant="primary"
              icon="stethoscope"
              class="text-mcred-700"
              :href="getAnchor(check)"
              :data-test="getTestId(`redlights-${index}-comment-doc-link`)"
              @click="toggleCheckOpen(check)"
            />
          </MedTooltip>
        </div>
      </li>

      <li v-if="checks.length === 0" :data-test="getTestId('redlights-empty')">
        Es wurden keine Risiken oder Probleme ermittelt.
      </li>
    </ul>
  </div>
</template>
